import { render, staticRenderFns } from "./PhotoBookBottomSheet.vue?vue&type=template&id=5834928e&"
import script from "./PhotoBookBottomSheet.vue?vue&type=script&lang=js&"
export * from "./PhotoBookBottomSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports